import React from 'react';
import { FiLayers, FiFileText, FiHeadphones } from 'react-icons/fi';

const cards = [
  {
    icon: <FiLayers className="h-5 w-5" />,
    iconClass: 'bg-[#e0f0ff] text-[#2b6cb0]',
    visual: 'from-[#c8dcf3] via-[#dde8f7] to-[#edf3fb]',
    title: 'Simplified Management',
    description:
      'Digitalbookshelfcare.com offers you to easily manage different subscriptions. Fill in the e-mail address you used when you subscribed and reach your customer account in one click.',
  },
  {
    icon: <FiFileText className="h-5 w-5" />,
    iconClass: 'bg-[#fff1e8] text-[var(--brand-accent)]',
    visual: 'from-[#f7bfa5] via-[#fad4c0] to-[#fde8db]',
    title: 'Essential Information',
    description:
      'All the essential information is there to give you maximum control of your subscriptions. You can also contact the agents to ask for help, unsubscribe or make a complaint.',
  },
  {
    icon: <FiHeadphones className="h-5 w-5" />,
    iconClass: 'bg-[#e0f8ec] text-[#276749]',
    visual: 'from-[#a0e0bf] via-[#b8e8d0] to-[#d0f0e0]',
    title: 'Expert Agents',
    description:
      'Our agents are experts in after-sales services and have all the answers to your questions. We work 7 days per week, so you can contact the agents by live chat or by phone.',
  },
];

export default function Features() {
  return (
    <section className="px-5 py-4 sm:px-8 pb-16">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-6 sm:grid-cols-3">
          {cards.map(card => (
            <div
              key={card.title}
              className="group relative overflow-hidden rounded-3xl border border-gray-100 bg-white shadow-sm transition-all duration-300 hover:-translate-y-2 hover:shadow-xl"
            >
              {/* Icon badge */}
              <div
                className={`absolute left-4 top-4 z-10 flex h-10 w-10 items-center justify-center rounded-xl shadow-sm ${card.iconClass}`}
              >
                {card.icon}
              </div>

              {/* Visual / image area */}
              <div className={`h-52 w-full bg-gradient-to-br ${card.visual} flex items-end justify-end p-4`}>
                <div className="opacity-20 text-7xl">{card.icon}</div>
              </div>

              {/* Text content */}
              <div className="p-5 pb-6">
                <h3 className="text-lg font-bold text-[var(--brand-ink)]">{card.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[var(--text-muted)]">{card.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
